// Module
var code = `{{#each this}}
    {{#if visible}}
        <div class="order-edit-parameter" {{#if !@this.getOrderEditParameterVisibility(this)}} style="display:none;" {{/if}}>

            {{#if type === DynProperty.DOUBLE}}
                <DPTradingNumeric dp="{{this}}" name="{{this.name}}" PriceNumericLink="{{PriceNumericLink}}" StopPriceNumericLink="{{StopPriceNumericLink}}" instrument="{{instrument}}"/>
                {{elseif type === DynProperty.POSITION_SIZING}}
                <DPPositionSizingControls dp="{{this}}" name="{{this.name}}" />
                {{elseif type === DynProperty.SLTP}}
                <DPSLTPControl dp="{{this}}" name="{{this.name}}" SLNumericLink="{{SLNumericLink}}" TPNumericLink="{{TPNumericLink}}" side="{{side}}" instrument="{{instrument}}"/>
                {{elseif type === DynProperty.COMBOBOX_COMBOITEM}}
                <DPBoundToControl dp="{{this}}" name="{{this.name}}" />
                {{elseif type === DynProperty.PRODUCT_TYPE_AND_MQ}}
                <DPProductTypeAndModifyQuantity dp="{{this}}" name="{{this.name}}" MQNumericLink="{{MQNumericLink}}" />
                {{elseif type === DynProperty.ATTENTION_MSG}}
                <DPAttentionMsg dp="{{this}}" name="{{this.name}}" />
            {{/if}}

        </div>
    {{/if}}
{{/each}}`;
// Exports
export default code;